import * as React from 'react';

/**
 * Debounces a fast-changing value so downstream effects (typically a fetch keyed on the value)
 * only fire `delayMs` after the most recent change. The first render returns the input
 * unchanged, then any subsequent change is held for `delayMs` before being committed.
 *
 * Internal helper shared by `useDebouncedInfiniteQuery` and `<ListPage>`'s hook-backed path so
 * the two pipelines apply the same search-debounce semantics.
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
	const [debounced, setDebounced] = React.useState<T>(value);

	React.useEffect(() => {
		const handle = setTimeout(() => setDebounced(value), delayMs);
		return () => clearTimeout(handle);
	}, [value, delayMs]);

	return debounced;
};
